// api.js
import axios from 'axios';

const api = axios.create({
    baseURL: 'https://crm-back-gamma.vercel.app/api', // Adjust base URL as needed
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interceptor to add JWT token to headers if it exists
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;
